<template>
   <div>
     <div class="search_unit">
        <div style='display:inline-block;'>
          <el-select v-model="drugid" clearable filterable placeholder="请选择药品">
            <el-option
              v-for="item in druglist"
              :key="item.id"
              :label="item.drugname+'/'+item.drugspec+'/'+item.drugcode"  
              :value="item.id">
              <span style="float: left">【药名】{{ item.drugname }}</span>
              <span style="float: left">【规格】{{ item.drugspec }}</span>
              <span style="float: left">【编码】{{ item.drugcode }}</span>
            </el-option>
          </el-select>
        </div>
        <div style='display:inline-block;'>
          <el-select v-model="drughospital" clearable filterable  placeholder="请选择医院">
            <el-option
              v-for="item in hospitallist"
              :key="item.id"
              :label="item.name"  
              :value="item.name">
            </el-option>
          </el-select>
        </div>
        <div style='display:inline-block;margin-left:5px;'>
          <el-input placeholder="请输入分销商姓名" v-model="name" @change="getList">
            <template slot="append"><span @click="getList">筛选数据</span></template>
          </el-input>
        </div>
        <div style='display:inline-block;margin-left:5px;float:right;'>
          <el-button type="primary" icon="el-icon-download" size="small" @click="doDownloadUserCommission">导出全部数据</el-button>
        </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%">
      <el-table-column
        prop="drughospital"
        label="医院"
        >
      </el-table-column>
      <el-table-column
        prop="druginfo"
        label="药品"
        >
      </el-table-column>
      <el-table-column
        label="绑定信息"
        >
        <template slot-scope="scope"> 
            <div v-for="item in scope.row.bindlist" :key="item.beeno">
              <div>小蜜蜂{{item.beeno }}:{{ item.name }}|佣金:{{ item.commission }}</div>
              <div v-if="item.starttime==0 && item.endtime==0">
                <span>状态：长期有效</span>
              </div>
              <div>
                <span v-if="item.starttime!=0">{{item.starttime | timeToDate2}}开始</span>
                <span v-if="item.endtime!=0">{{item.endtime | timeToDate2}}截止</span>
              </div> 
            </div>  
        </template>
      </el-table-column>
      <el-table-column
        label="更新时间">
        <template slot-scope="scope"> 
           {{scope.row.createtime | timeToDate}}    
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope"> 
          <el-button type="primary" icon="el-icon-edit" @click="handleEdit(scope.row.drughospital,scope.row.drugid)" size="small">编辑</el-button>
          <el-button type="danger" icon="el-icon-delete" @click="handleDelete(scope.row.drughospital,scope.row.drugid)" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
      <div class='page-number'>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="pageinfo.total"
          :page-size="pageinfo.pagesize"
          :current-page.sync="pageinfo.pageindex"
          @current-change='getList'
          >
        </el-pagination>
      </div>
      <el-dialog
        title="编辑小蜜蜂"
        :visible.sync="editSourceVisible"
        :fullscreen="true"
        @close="handleClose"
        >
        <EditSource :comdrugid="curDrugid" :comdrughospital="curDrughospital" v-if="editSourceVisible"/>
      </el-dialog>
   </div> 
</template>

<script>
import {downloadUserCommission} from '../../api/index'
import EditSource from '../addbindbee/index.vue'

export default {
  data(){
     return {
        editSourceVisible:false,
        curDrugid:'',
        curDrughospital:'',

        tableData:[],
        keywords:'',
        pageinfo:{
          total:0,
          pagesize:10,
          pageindex:1
        },
        hospitallist:[],
        druglist:[],
        drughospital:'',
        drugid:'',
        name:'',
        processing:false
     }
  },
  components:{
    EditSource
  },
  created(){
     this.getList()
  },
  methods: {
      getList(){
          this.$post("/userCommission/getUserComList",{pageinfo:this.pageinfo,drugid:this.drugid,drughospital:this.drughospital,name:this.name}).then((data)=>{
               if(data.result.success){
                  this.tableData=data.result.info.usercomlist
                  this.pageinfo=data.result.info.pageinfo 
                  this.druglist=data.result.info.druglist
                  this.hospitallist=data.result.info.hospitallist
               }else{
                  this.$message.error(data.result.info)
               }
          })
      },
      handleEdit(drughospital,drugid){
         this.curDrughospital=drughospital
         this.curDrugid=drugid
         this.editSourceVisible=true
      },
      handleClose(){
         this.getList()
      },
      handleDelete(drughospital,drugid){
        this.$confirm('此操作将删除该佣金配置,与之相关的奖励会发生变化, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
           this.doDelete(drughospital,drugid)
        }).catch(() => {
                     
        }); 
      },
      doDelete(drughospital,drugid){
        if(this.processing){
           this.$message.error("请等待处理完成");return false
        }
        this.processing=true
        this.$post("/userCommission/delUserCommission",{drughospital:drughospital,drugid:drugid}).then((data)=>{
               this.processing=false
               if(data.result.success){
                  this.$message({message:data.result.info,type:'success'})
                  setTimeout(()=>{this.getList()},500)
               }else{
                  this.$message.error(data.result.info)
               }
        })
      },
      doDownloadUserCommission(){
        downloadUserCommission("/download/downloadUserCommission",{}) 
      }
  }
}
</script>

<style scoped lang="scss">
.page-number{margin-top:20px;float:right;}
.search-unit{margin-top: 15px;}
/deep/ .el-select .el-input {width: 300px!important}

</style>
